export const API_SERVICE_URL = process.env.EXPO_PUBLIC_API_DD_SERVICE_URL;

export const API_DD_MEDIA_TEMP_UPLOAD_URL =
  process.env.EXPO_PUBLIC_API_DD_MEDIA_TEMP_UPLOAD_URL;

export const API_DD_DOCUMENT_TEMP_UPLOAD_URL =
  process.env.EXPO_PUBLIC_API_DD_DOCUMENT_TEMP_UPLOAD_URL;

export const APP_VARIANT_HEADER_NAME = 'appVariantIdentifier';
